module.exports = __webpack_public_path__ + "img/invitebanner.e2f29a19.png";